<template>
  <div class="help">
    <div class="header">上海市法人一证通小程序使用手册</div>
    <div class="help_content">
      <div @click="openImg('img1')" class="content">
        <img src="@/assets/help1.png" alt="" />
        <div class="title">
          <p>登录</p>
          <p>“上海市法人一证通”小程序</p>
        </div>
      </div>
      <div @click="openImg('img2')" class="content">
        <div class="logo">
          <div class="logo_text">推荐</div>
        </div>
        <img src="@/assets/help2.png" alt="" />
        <div class="title">
          <p>选择“法定代表人认证”</p>
          <p>申请法人一证通</p>
        </div>
      </div>
      <div @click="openImg('img3')" class="content">
        <div class="logo">
          <div class="logo_text">推荐</div>
        </div>
        <img src="@/assets/help3.png" alt="" />
        <div class="title">
          <p>选择“法人一证通介质授权”</p>
          <p>申请法人一证通 拷贝</p>
        </div>
      </div>
    </div>
    <div class="help_content">
      <div @click="openImg('img4')" class="content">
        <img src="@/assets/help4.png" alt="" />
        <div class="title">
          <p>选择“电子营业执照授权”</p>
          <p>申请法人一证通</p>
        </div>
      </div>
      <div @click="openImg('img5')" class="content">
        <img src="@/assets/help5.png" alt="" />
        <div class="title">
          <p>法人一证通授权</p>
        </div>
      </div>
      <div @click="openImg('img6')" class="content">
        <img src="@/assets/help6.png" alt="" />
        <div class="title">
          <p>使用法人一证通</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    alert() {
      this.$message.warning("内容建设中！");
    },
    openImg(imgPath) {
      this.$router.push({path: "/img", query: {imgPath}});
      // window.open('../assets/img.png')
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  padding-bottom: 100px;
}
.header {
  // width: 100%;
  height: 100px;
  line-height: 100px;
  background: #cd3241;
  text-align: center;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.help_content {
  display: flex;
  width: 950px;
  // width: 780px;
  align-items: center;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 53px;
  .content {
    position: relative;
    cursor: pointer;
    width: 290px;
    height: 172px;
    background: #ffffff;
    border: 1px solid #cacaca;
    border-radius: 6px;
    padding-top: 16px;
    .title {
      margin-top: 17px;
    }
    img {
      width: 82px;
      height: 82px;
    }
    p {
      margin: 0;
      padding: 0;
      font-size: 18px;
      line-height: 25px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3c4669;
    }
    .logo {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border: 30px solid;
      border-color: #e14654 #e14654 transparent transparent;
      border-radius: 0 6px;
      &_text {
        position: absolute;
        width: 40px;
        top: -20px;
        right: -30px;
        transform: rotate(43deg);
        color: #fff;
      }
    }
  }
}
</style>